import {ITag} from "../pages/field-management/custom-field/DraggableTag";

export const getNextDisplayOrder = (tags: ITag[]) => {
  if (tags.length === 0) {
    return 1; // Returns displayOrder 1 if the array is empty
  }
  
  return tags.reduce((a, b) => Math.max(a, b.displayOrder), -Infinity) + 1;
};
